import { ReactElement } from "react";
import styles from "./TimeOff.module.css";
import WorkingOnAHoliday from "./components/StatutoryHolidayHours/WorkingOnAHoliday";
import AdditionalLeave from "./components/UnpaidLeave/AdditionalLeave";
import History from "./components/History/History";
import { Policies } from "./components/Policies/Policies";
import { UpcomingRequests } from "./components/UpcomingRequests/UpcomingRequests";
import {
  NeonSkyContext,
  NeonSkyFeatureFlag,
} from "lib/neon-sky/neon-sky-provider";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { buildASOPath } from "lib/resource-finder";

export default function TimeOff(): ReactElement {
  const { featureFlags } = useContext(NeonSkyContext);

  // Time off transfer to Neon
  const isNeonMemberProfileEnabled =
    featureFlags[NeonSkyFeatureFlag.TIME_OFF_MEMBER_PROFILE];
  const { id } = useParams();
  if (isNeonMemberProfileEnabled) {
    window.location.href = buildASOPath(`/member/${id}/time-off`);
  }

  return (
    <>
      <div className={styles.cardSection}>
        <Policies />
        <AdditionalLeave />
        <WorkingOnAHoliday />
        <UpcomingRequests />
        <History />
      </div>
    </>
  );
}
